module.exports = __webpack_public_path__ + "img/neowalls.614652e9.png";